
(function () {
  "use strict";

  var NAUTIYA_SWATCHES = {
    "paddle-gonflable-tropical": ["#46de13", "#13d0ed", "#e0b8df"],
    "paddle-gonflable-sunset":   ["#af89da", "#276fd3", "#34dcd3"],
    "paddle-gonflable-pro":      ["#004c54", "#20a4c3"],
    "paddle-gonflable-tiki":     ["#96d296", "#0392a2"],
    "paddle-gonflable-oak":      ["#77898b", "#2a376e"],
    "paddle-gonflable-teak":     ["#795b5a", "#b1918c"],
    "paddle-gonflable-floral":   ["#f739b7", "#d04ec0"]
  };

  var LOGO_SRC = "https://cdn.shopify.com/s/files/1/0946/7412/5185/files/Nautiya_logo_fond_transparent.png?v=1782158705";
  var HEART_SVG = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 21C12 21 3 14.5 3 8.5C3 5.42 5.42 3 8.5 3C10.24 3 11.91 3.81 13 5.08C14.09 3.81 15.76 3 17.5 3C20.58 3 23 5.42 23 8.5C23 14.5 12 21 12 21Z"/></svg>';
  var CHEV_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';

  function handleFromCard(card) {
    try {
      var a = card.matches && card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
      if (!a) return null;
      var href = a.getAttribute('href') || '';
      var m = href.split('/products/')[1];
      if (!m) return null;
      return m.split('?')[0].split('#')[0].split('/')[0];
    } catch (e) { return null; }
  }

  function priceToNumber(txt) {
    if (!txt) return 0;
    var cleaned = txt.replace(/[^0-9.,]/g, '').replace(/\s/g, '');
    if (cleaned.indexOf(',') > -1 && cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
      cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    } else {
      cleaned = cleaned.replace(/,/g, '');
    }
    var n = parseFloat(cleaned);
    if (isNaN(n)) return 0;
    return Math.round(n * 100);
  }

  function enhanceCard(card) {
    try {
      if (!card || card.dataset.npcDone) return;
      card.dataset.npcDone = '1';

      var handle = handleFromCard(card);

      var info   = card.querySelector('.mz-so-gong-card-info') || card;
      var vendor = card.querySelector('.mz-so-gong-card-vendor');
      var titleEl = card.querySelector('.mz-so-gong-card-title');
      var imgEl  = card.querySelector('.mz-so-gong-card-img img');
      var priceEl = card.querySelector('.mz-so-gong-price-current') || card.querySelector('.mz-so-gong-card-price');

      if (vendor) {
        vendor.textContent = '';
        var img = document.createElement('img');
        img.className = 'mzso-logo';
        img.src = LOGO_SRC;
        img.alt = 'Nautiya';
        vendor.appendChild(img);
      } else {
        vendor = document.createElement('div');
        vendor.className = 'mz-so-gong-card-vendor';
        var li = document.createElement('img');
        li.className = 'mzso-logo';
        li.src = LOGO_SRC;
        li.alt = 'Nautiya';
        vendor.appendChild(li);
        if (info.firstChild) { info.insertBefore(vendor, info.firstChild); }
        else { info.appendChild(vendor); }
      }

      if (!card.querySelector('.mzso-wish')) {
        var title = titleEl ? (titleEl.textContent || '').trim() : '';
        var image = imgEl ? (imgEl.getAttribute('src') || '') : '';
        var price = priceEl ? priceToNumber(priceEl.textContent || '') : 0;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mzso-wish';
        if (handle) btn.setAttribute('data-handle', handle);
        btn.setAttribute('data-title', title);
        btn.setAttribute('data-image', image);
        btn.setAttribute('data-price', String(price));
        btn.setAttribute('aria-label', 'Zu den Favoriten hinzufügen');
        btn.innerHTML = HEART_SVG;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (window.mzToggleWish) { window.mzToggleWish(this); }
        });
        vendor.appendChild(btn);
      }

      var priceRow = card.querySelector('.mz-so-gong-card-price');
      var bottomRow = card.querySelector('.mzso-row-bottom');
      if (priceRow && !bottomRow) {
        bottomRow = document.createElement('div');
        bottomRow.className = 'mzso-row-bottom';
        priceRow.parentNode.insertBefore(bottomRow, priceRow);
        bottomRow.appendChild(priceRow);
      }

      var cols = handle ? NAUTIYA_SWATCHES[handle] : null;
      if (cols && cols.length && !card.querySelector('.mzso-swatches')) {
        var sw = document.createElement('div');
        sw.className = 'mzso-swatches';
        for (var i = 0; i < cols.length; i++) {
          var sp = document.createElement('span');
          sp.className = 'mzso-swatch' + (i === 0 ? ' is-active' : '');
          sp.style.background = cols[i];
          sw.appendChild(sp);
        }
        if (bottomRow) {
          bottomRow.appendChild(sw);
        } else if (priceRow && priceRow.parentNode) {
          priceRow.parentNode.insertBefore(sw, priceRow.nextSibling);
        } else {
          info.appendChild(sw);
        }
      }

      if (window.mzSyncHearts) { window.mzSyncHearts(); }
    } catch (e) {}
  }

  function enhanceCollections() {
    try {
      var titles = document.querySelectorAll('.mz-so-gong-filter-title');
      for (var t = 0; t < titles.length; t++) {
        var titleEl = titles[t];
        var sidebar = titleEl.closest('.mz-so-gong-sidebar');
        if (!sidebar) continue;
        if (sidebar.dataset.npcCollDone === '1') continue;

        var rawTxt = (titleEl.textContent || '');
        if (rawTxt.toLowerCase().indexOf('kategor') === -1 &&
            rawTxt.toLowerCase().indexOf('categor') === -1) {
          continue;
        }

        sidebar.dataset.npcCollDone = '1';

        var replaced = false;
        for (var n = 0; n < titleEl.childNodes.length; n++) {
          var node = titleEl.childNodes[n];
          if (node.nodeType === 3 && /catégor|categor/i.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(/catégorie|kategorien|categorie|categories/gi, 'Kollektion');
            replaced = true;
          }
        }
        if (!replaced) {
          titleEl.firstChild && (titleEl.firstChild.nodeType === 3) &&
            (titleEl.firstChild.nodeValue = 'Kollektion ');
        }

        var list = sidebar.querySelector('.mz-so-gong-filter-list');
        if (list) {
          list.classList.add('npc-coll-cards');
          var items = list.querySelectorAll('.mz-so-gong-filter-item');
          for (var k = 0; k < items.length; k++) {
            var item = items[k];
            if (item.dataset.npcCollItem === '1') continue;
            item.dataset.npcCollItem = '1';
            item.classList.add('npc-coll-card');

            var label = (item.textContent || '').trim();
            var safeLabel = label.replace(/</g, '&lt;').replace(/>/g, '&gt;');
            item.innerHTML =
              '<span class="npc-coll-card-label">' + safeLabel + '</span>';
          }
        }

        var layout = sidebar.closest('.mz-so-gong-layout') || sidebar.parentNode;
        var grid = layout ? layout.querySelector('.mz-so-gong-grid') : null;
        sidebar.classList.add('npc-coll-moved');
        if (grid && grid.parentNode) {
          if (grid.nextSibling !== sidebar) {
            grid.parentNode.insertBefore(sidebar, grid.nextSibling);
          }
        }
      }
    } catch (e) {}
  }

  /* =========================================================================
     ETAT VIDE (loupe cliquee, sans saisie) : Recherches frequentes + Categories
     Cible par TEXTE/STRUCTURE (robuste), idempotent (dataset flags),
     reapplique a chaque ouverture via l'observer.
     ========================================================================= */
  var FREQ_LABELS = ['häufige suchanfragen', 'häufige suchanfrage', 'recherches frequentes'];
  var CAT_LABELS  = ['kategorien', 'categories', 'kategorie', 'categorie'];

  function txt(el) { return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim(); }
  function low(el) { return txt(el).toLowerCase(); }

  function isSnorkel(el) {
    try {
      if (!el) return false;
      var t = txt(el).toLowerCase();
      if (t.indexOf('snorkel') !== -1) return true;
      var imgs = el.querySelectorAll ? el.querySelectorAll('img[alt]') : [];
      for (var i = 0; i < imgs.length; i++) {
        if ((imgs[i].getAttribute('alt') || '').toLowerCase().indexOf('snorkel') !== -1) return true;
      }
      if (el.tagName === 'IMG' &&
          (el.getAttribute('alt') || '').toLowerCase().indexOf('snorkel') !== -1) return true;
      var links = [];
      if (el.tagName === 'A') links.push(el);
      if (el.querySelectorAll) {
        var a2 = el.querySelectorAll('a[href]');
        for (var j = 0; j < a2.length; j++) links.push(a2[j]);
      }
      for (var k = 0; k < links.length; k++) {
        if ((links[k].getAttribute('href') || '').toLowerCase().indexOf('snorkel') !== -1) return true;
      }
    } catch (e) {}
    return false;
  }

  function findZoneByLabel(root, labels) {
    try {
      var cand = root.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,div,strong,label,legend');
      for (var i = 0; i < cand.length; i++) {
        var t = low(cand[i]);
        for (var j = 0; j < labels.length; j++) {
          if (t === labels[j]) {
            return cand[i].parentNode || cand[i];
          }
        }
      }
    } catch (e) {}
    return null;
  }

  function findTitleEl(root, labels) {
    try {
      var cand = root.querySelectorAll('h1,h2,h3,h4,h5,h6,p,span,div,strong,label,legend');
      for (var i = 0; i < cand.length; i++) {
        var t = low(cand[i]);
        for (var j = 0; j < labels.length; j++) {
          if (t === labels[j]) return cand[i];
        }
      }
    } catch (e) {}
    return null;
  }

  function overlayRoot() {
    return document.getElementById('mzSearchOverlay') ||
           document.querySelector('.mz-search-overlay') ||
           document;
  }

  function isVisible(el) {
    try {
      return !!el &&
             el.offsetParent !== null &&
             el.getClientRects().length > 0 &&
             getComputedStyle(el).visibility !== 'hidden' &&
             el.offsetWidth > 0;
    } catch (e) { return false; }
  }

  function maxZIndex(el) {
    var z = 0;
    try {
      var node = el;
      while (node && node !== document.body && node.nodeType === 1) {
        var zi = parseInt(getComputedStyle(node).zIndex, 10);
        if (!isNaN(zi)) z = Math.max(z, zi);
        node = node.parentElement;
      }
    } catch (e) {}
    return z;
  }

  function getOverlayInput() {
    try {
      var cands = Array.prototype.slice.call(
        document.querySelectorAll('input[type=search], input[placeholder]')
      );
      cands = cands.filter(function (el) {
        var ph = (el.getAttribute('placeholder') || '').toLowerCase();
        return ph.indexOf('recherch') !== -1;
      });
      var pref = document.getElementById('mzSoInput');
      if (pref) cands.push(pref);
      var mz = document.querySelectorAll('.mz-so-input');
      for (var p = 0; p < mz.length; p++) cands.push(mz[p]);

      var uniq = [];
      for (var i = 0; i < cands.length; i++) {
        if (cands[i] && uniq.indexOf(cands[i]) === -1) uniq.push(cands[i]);
      }
      var visible = uniq.filter(isVisible);
      if (!visible.length) return null;

      for (var m = 0; m < visible.length; m++) {
        if (visible[m].id === 'mzSoInput' ||
            (visible[m].classList && visible[m].classList.contains('mz-so-input'))) {
          return visible[m];
        }
      }
      var best = null, bestScore = -Infinity;
      for (var v = 0; v < visible.length; v++) {
        var el = visible[v];
        var score = 0;
        if (el.closest && el.closest('#mzSearchOverlay, .mz-search-overlay')) score += 1000000;
        score += maxZIndex(el);
        try { score -= (el.getBoundingClientRect().top || 0) / 1000; } catch (e) {}
        if (score > bestScore) { bestScore = score; best = el; }
      }
      return best || visible[0];
    } catch (e) { return null; }
  }

  function clickablesIn(zone) {
    if (!zone) return [];
    var nodes = zone.querySelectorAll('a, button, [role="button"], li');
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.querySelector && n.querySelector('a, button, [role="button"]')) continue;
      var t = txt(n);
      if (t) out.push(n);
    }
    return out;
  }

  function fireSearch(input, value) {
    try {
      input.value = value;
      input.focus();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      try {
        input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: value.slice(-1) || 'a' }));
      } catch (e2) {
        var ev = document.createEvent('Event');
        ev.initEvent('keyup', true, true);
        input.dispatchEvent(ev);
      }
    } catch (e) {}
  }

  function hideSnorkelGlobal(root) {
    try {
      if (!root || !root.querySelectorAll) return;
      var nodes = root.querySelectorAll('a, button, [role="button"], li');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (!el || el.classList.contains('npc-empty-hide')) continue;

        var t = txt(el).toLowerCase();

        if (t.indexOf('paddle') !== -1 || t.indexOf('kayak') !== -1 || t.indexOf('gonflable') !== -1) continue;

        if (t.length >= 30) continue;

        var inner = el.querySelectorAll ? el.querySelectorAll('a, button, [role="button"]') : [];
        if (inner.length >= 1) continue;

        var hit = (t.indexOf('snorkel') !== -1);
        if (!hit) {
          try {
            if (el.tagName === 'A' &&
                (el.getAttribute('href') || '').toLowerCase().indexOf('snorkel') !== -1) {
              hit = true;
            }
            if (!hit && el.querySelectorAll) {
              var as = el.querySelectorAll('a[href]');
              for (var a = 0; a < as.length; a++) {
                if ((as[a].getAttribute('href') || '').toLowerCase().indexOf('snorkel') !== -1) { hit = true; break; }
              }
            }
          } catch (e2) {}
        }

        if (hit) el.classList.add('npc-empty-hide');
      }
    } catch (e) {}
  }

  function enhanceEmptyState() {
    try {
      var root = overlayRoot();
      if (!root || !root.querySelectorAll) return;

      var freqZone = findZoneByLabel(root, FREQ_LABELS);
      if (freqZone) {
        var pills = clickablesIn(freqZone);
        for (var i = 0; i < pills.length; i++) {
          var pill = pills[i];

          if (isSnorkel(pill)) {
            pill.classList.add('npc-empty-hide');
            continue;
          }

          if (pill.dataset.npcFreqBound !== '1') {
            pill.dataset.npcFreqBound = '1';
            (function (term) {
              pill.addEventListener('click', function (e) {
                try {
                  e.preventDefault();
                  e.stopPropagation();
                } catch (err) {}
                var input = getOverlayInput();
                if (input) fireSearch(input, term);
              }, true);
            })(txt(pill));
          }
        }
      }

      var catZone = findZoneByLabel(root, CAT_LABELS);
      if (catZone) {
        var tiles = clickablesIn(catZone);
        for (var k = 0; k < tiles.length; k++) {
          if (isSnorkel(tiles[k])) {
            tiles[k].classList.add('npc-empty-hide');
          }
        }
      }

      hideSnorkelGlobal(root);

      var catTitle = findTitleEl(root, ['kategorien', 'categories']);
      if (catTitle && catTitle.dataset.npcCatTitleDone !== '1') {
        if (!catTitle.closest('.mz-so-gong-filter-title') &&
            !catTitle.classList.contains('mz-so-gong-filter-title')) {
          var only = true;
          for (var c = 0; c < catTitle.childNodes.length; c++) {
            if (catTitle.childNodes[c].nodeType !== 3) { only = false; break; }
          }
          if (only) {
            catTitle.textContent = 'KOLLEKTION';
          } else {
            for (var d = 0; d < catTitle.childNodes.length; d++) {
              var nd = catTitle.childNodes[d];
              if (nd.nodeType === 3 && /catégories|categories/i.test(nd.nodeValue)) {
                nd.nodeValue = nd.nodeValue.replace(/catégories|categories/gi, 'KOLLEKTION');
              }
            }
          }
          catTitle.dataset.npcCatTitleDone = '1';
        }
      }
    } catch (e) {}
  }

  var ACC_DEFS = [
    { key: 'coll', title: 'Kollektion', open: false },
    { key: 'prod', title: 'Produkt',    open: true  },
    { key: 'blog', title: 'Blog',       open: false },
    { key: 'page', title: 'Pages',      open: false }
  ];

  var lastBlogPagesTerm = null;
  var pendingTerm = null;
  var bpDebounce = null;

  function getInput() {
    return document.querySelector('.mz-so-input') || document.getElementById('mzSoInput');
  }
  function currentTerm() {
    var inp = getInput();
    return inp ? (inp.value || '').trim() : '';
  }

  function syncProdOpen(acc) {
    try {
      if (!acc) acc = document.querySelector('.npc-acc');
      if (!acc) return;
      var wrap = acc.closest('.npc-acc-wrap');
      if (!wrap) {
        var r = document.getElementById('mzSoResults') || document.querySelector('.mz-so-results');
        wrap = r ? r.querySelector('.npc-acc-wrap') : null;
      }
      var prodSec = acc.querySelector('.npc-acc-sec[data-npc-sec="prod"]');
      var open = prodSec ? prodSec.classList.contains('is-open') : true;
      if (wrap) wrap.setAttribute('data-npc-prod-open', open ? '1' : '0');
    } catch (e) {}
  }

  function buildAccordion() {
    try {
      var results = document.getElementById('mzSoResults') ||
                    document.querySelector('.mz-so-results');
      if (!results) return null;

      var layout = results.querySelector('.mz-so-gong-layout');
      var grid   = results.querySelector('.mz-so-gong-grid');
      if (!grid) return document.querySelector('.npc-acc');

      var acc = results.querySelector('.npc-acc');
      if (!acc) {
        acc = document.createElement('div');
        acc.className = 'npc-acc';
        acc.dataset.npcAcc = '1';

        for (var i = 0; i < ACC_DEFS.length; i++) {
          var def = ACC_DEFS[i];
          var sec = document.createElement('section');
          sec.className = 'npc-acc-sec' + (def.open ? ' is-open' : '');
          sec.dataset.npcSec = def.key;

          var head = document.createElement('button');
          head.type = 'button';
          head.className = 'npc-acc-head';
          head.setAttribute('aria-expanded', def.open ? 'true' : 'false');
          head.innerHTML =
            '<span class="npc-acc-title">' + def.title + '</span>' +
            '<span class="npc-acc-count" data-npc-count="' + def.key + '">(0)</span>' +
            '<span class="npc-acc-chev">' + CHEV_SVG + '</span>';
          head.addEventListener('click', function () {
            var s = this.closest('.npc-acc-sec');
            if (!s) return;
            var open = s.classList.toggle('is-open');
            this.setAttribute('aria-expanded', open ? 'true' : 'false');
            if (s.dataset.npcSec === 'prod') {
              syncProdOpen(s.closest('.npc-acc'));
            }
          });

          var body = document.createElement('div');
          body.className = 'npc-acc-body';
          body.dataset.npcBody = def.key;

          sec.appendChild(head);
          sec.appendChild(body);
          acc.appendChild(sec);
        }

        if (layout && layout.parentNode === results) {
          results.insertBefore(acc, layout);
        } else {
          results.appendChild(acc);
        }
      }

      var wrap = results.querySelector('.npc-acc-wrap');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'npc-acc-wrap';
        wrap.dataset.npcWrap = '1';

        var aside = document.createElement('div');
        aside.className = 'npc-acc-aside';
        aside.dataset.npcAside = '1';

        var main = document.createElement('div');
        main.className = 'npc-acc-main';
        main.dataset.npcMain = '1';

        if (acc.parentNode) {
          acc.parentNode.insertBefore(wrap, acc);
        } else {
          results.appendChild(wrap);
        }
        aside.appendChild(acc);
        wrap.appendChild(aside);
        wrap.appendChild(main);
      }

      var aside2 = wrap.querySelector('.npc-acc-aside');
      var main2  = wrap.querySelector('.npc-acc-main');

      if (aside2 && acc.parentNode !== aside2) {
        aside2.appendChild(acc);
      }

      var bodyProd = acc.querySelector('[data-npc-body="prod"]');
      var bodyColl = acc.querySelector('[data-npc-body="coll"]');

      if (main2 && grid && grid.parentNode !== main2) {
        main2.appendChild(grid);
      }

      var sidebar = results.querySelector('.mz-so-gong-sidebar') ||
                    (layout ? layout.querySelector('.mz-so-gong-sidebar') : null);
      if (bodyColl && sidebar && sidebar.parentNode !== bodyColl) {
        bodyColl.appendChild(sidebar);
      }

      updateProdCount(acc);
      updateCollCount(acc);
      syncProdOpen(acc);

      return acc;
    } catch (e) { return null; }
  }

  function setCount(acc, key, n) {
    try {
      var el = acc.querySelector('[data-npc-count="' + key + '"]');
      if (el) el.textContent = '(' + (n || 0) + ')';
    } catch (e) {}
  }

  function updateProdCount(acc) {
    if (!acc) acc = document.querySelector('.npc-acc');
    if (!acc) return;
    var n = document.querySelectorAll('#mzSoResults .mz-so-gong-card, .mz-so-results .mz-so-gong-card').length;
    setCount(acc, 'prod', n);
  }

  function updateCollCount(acc) {
    if (!acc) acc = document.querySelector('.npc-acc');
    if (!acc) return;
    var cards = document.querySelectorAll('.npc-acc [data-npc-body="coll"] .npc-coll-card');
    var n = cards.length;
    if (!n) {
      n = document.querySelectorAll('.npc-acc [data-npc-body="coll"] .mz-so-gong-filter-item').length;
    }
    setCount(acc, 'coll', n);
  }

  function injectLinkList(acc, key, items) {
    try {
      var body = acc.querySelector('[data-npc-body="' + key + '"]');
      if (!body) return;
      body.innerHTML = '';
      if (!items || !items.length) {
        var empty = document.createElement('div');
        empty.className = 'npc-link-empty';
        empty.textContent = 'Aucun resultat.';
        body.appendChild(empty);
        return;
      }
      var ul = document.createElement('ul');
      ul.className = 'npc-link-list';
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (!it || !it.url) continue;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'npc-link-item';
        a.href = it.url;
        a.textContent = it.title || it.url;
        li.appendChild(a);
        ul.appendChild(li);
      }
      body.appendChild(ul);
    } catch (e) {}
  }

  function fetchBlogPages() {
    var term = currentTerm();
    var acc = document.querySelector('.npc-acc');
    if (!acc) return;

    if (!term) {
      lastBlogPagesTerm = '';
      injectLinkList(acc, 'blog', []);
      injectLinkList(acc, 'page', []);
      setCount(acc, 'blog', 0);
      setCount(acc, 'page', 0);
      return;
    }

    var pageBody = acc.querySelector('[data-npc-body="page"]');
    var blogBody = acc.querySelector('[data-npc-body="blog"]');
    var bodyEmpty = (pageBody && !pageBody.querySelector('.npc-link-item, .npc-link-empty')) ||
                    (blogBody && !blogBody.querySelector('.npc-link-item, .npc-link-empty'));
    if (term === lastBlogPagesTerm && !bodyEmpty) return;

    pendingTerm = term;
    var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
              '&resources[type]=product,article,page' +
              '&resources[limit]=6' +
              '&resources[options][unavailable_products]=last';

    try {
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (term !== pendingTerm) return;
          if (currentTerm() !== term) return;

          var res = (data && data.resources && data.resources.results) || {};
          var articles = res.articles || [];
          var pages = res.pages || [];

          var blogItems = [];
          for (var a = 0; a < articles.length; a++) {
            if (articles[a] && articles[a].url) {
              blogItems.push({ title: articles[a].title, url: articles[a].url });
            }
          }
          var pageItems = [];
          for (var p = 0; p < pages.length; p++) {
            if (pages[p] && pages[p].url) {
              pageItems.push({ title: pages[p].title, url: pages[p].url });
            }
          }

          var acc2 = document.querySelector('.npc-acc');
          if (!acc2) return;
          injectLinkList(acc2, 'blog', blogItems);
          injectLinkList(acc2, 'page', pageItems);
          setCount(acc2, 'blog', blogItems.length);
          setCount(acc2, 'page', pageItems.length);
          lastBlogPagesTerm = term;
        })
        .catch(function () {});
    } catch (e) {}
  }

  function scheduleBlogPages() {
    if (bpDebounce) clearTimeout(bpDebounce);
    bpDebounce = setTimeout(fetchBlogPages, 200);
  }

  var rebuilding = false;
  function rebuildAccordion() {
    if (rebuilding) return;
    rebuilding = true;
    try {
      var acc = buildAccordion();
      if (acc) {
        updateProdCount(acc);
        updateCollCount(acc);
        syncProdOpen(acc);
        scheduleBlogPages();
      }
    } catch (e) {}
    rebuilding = false;
  }

  function enhanceAll() {
    try {
      var cards = document.querySelectorAll('.mz-so-gong-card');
      for (var i = 0; i < cards.length; i++) {
        if (!cards[i].dataset.npcDone) enhanceCard(cards[i]);
      }
      enhanceCollections();
      enhanceEmptyState();
      rebuildAccordion();
    } catch (e) {}
  }

  function start() {
    try {
      enhanceAll();
      var timer = null;
      var obs = new MutationObserver(function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(enhanceAll, 60);
      });
      obs.observe(document.body, { childList: true, subtree: true });

      document.addEventListener('input', function (e) {
        var inp = e.target;
        if (inp && inp.classList && inp.classList.contains('mz-so-input')) {
          scheduleBlogPages();
        }
      }, true);

      document.addEventListener('click', function () {
        setTimeout(enhanceEmptyState, 80);
      }, true);
      document.addEventListener('focusin', function (e) {
        var t = e.target;
        if (t && t.classList && (t.classList.contains('mz-so-input') || t.id === 'mzSoInput')) {
          setTimeout(enhanceEmptyState, 40);
        }
      }, true);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
